/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import LastErrors from "../components/Dashboard/LastErrors.jsx";
import StatusGridNodes from "../components/Dashboard/StatusGridNodes.jsx";
import StatusGridBuildServers from "../components/Dashboard/StatusGridBuildServers.jsx";
import CardComponent from "../components/CardComponent.jsx";
import StartGrid from "../components/StartGrid.jsx";
import ResourceUtilizationChart from "../components/Charts/ResourceUtilizationChart.jsx";
import ActiveDeployments from "../components/ActiveDeployments.jsx";

function Dashboard() {

    return (
        <div className={"space-y-3"}>


            <h1>Your Apps:</h1>
            <ActiveDeployments/>

            <div>
                <StartGrid/>

            </div>
            <CardComponent title={"Nodes "} isDefaultOpen={true}>
                <StatusGridNodes/>
            </CardComponent>
            <CardComponent title={"Build Servers"} isDefaultOpen={true}>
                <StatusGridBuildServers/>
            </CardComponent>
            <CardComponent title={"Resource Utilization"} isDefaultOpen={true}>
                <ResourceUtilizationChart/>

            </CardComponent>

            <CardComponent title={"Last errors"} isDefaultOpen={false}>
                <LastErrors name={"Nodes"}/>

            </CardComponent>


        </div>
    );
}

Dashboard.propTypes = {};

Dashboard.defaultProps = {};


export default Dashboard;